import { serializeFormQuery } from '@/lib/utils';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '@/shared/constants/pagination';
import { useSearchParams } from 'react-router-dom';

interface QueryParams {
  [key: string]: string | number;
}

const useSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { query: queryString } = Object.fromEntries(searchParams.entries());

  const queryCurrent: QueryParams = queryString?.split('&')
    .reduce((acc: QueryParams, param: string) => {
      const [key, value] = param.split('=');
      acc[key] = isNaN(Number(value)) ? value : Number(value);
      return acc;
    }, {}) ?? {};

  // Restoring a search form needs each value exactly as the user typed it, which
  // the map above cannot give: it coerces "01" to the number 1, and splitting by
  // hand never percent-decodes, so a Japanese keyword reads back as "%E3%82%B3…".
  // URLSearchParams undoes both the percent-encoding and the "+" for spaces that
  // handleSearch introduced when it wrote the query string.
  const queryRaw: Record<string, string> = Object.fromEntries(
    new URLSearchParams(queryString ?? ''),
  );

  function handleSearch(values: any) {
    //  eslint-disable-next-line
    const { limit, paginate, ...rest } = queryCurrent;
    const valuesSerialize = serializeFormQuery(values);
    if (JSON.stringify(valuesSerialize) == JSON.stringify(rest)) return;

    if (values.reset) {
      setSearchParams({});
      return;
    }
    const query = new URLSearchParams(
      serializeFormQuery({
        ...values,
        limit: DEFAULT_PER_PAGE,
        paginate: DEFAULT_PAGE,
      }),
    ).toString();
    setSearchParams({
      ...searchParams,
      query,
    });
  }

  return {
    handleSearch,
    searchParams,
    queryString,
    query: queryCurrent,
    queryRaw,
  };
};

export default useSearch;
